import TransferList from "./components/TransferList";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { serviceRoutes } from "./config/serviceRegistry";
import "./components/ServiceTheme.css";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<TransferList />} />
          {serviceRoutes.map(({ id, path, component: Component }) => (
            <Route key={id} path={path} element={<Component />} />
          ))}
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
}

export default App;
